import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as service from './service';
import CreateContent from './CreateContent';
import EditContent from './EditContent';
import CustomBodyContent from './CustomBodyContent';
import { LandPage, Container, Main } from './styles';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';

export default function Funcionarios() {
  const [data, setData] = useState([]);
  const [loadedData, setLoadedData] = useState(true);
  const [mountedData, setMountedData] = useState();

  const { perfil } = useSelector(state => state.auth);

  async function fetchFuncionarios() {
    if (!perfil?.idEmpresa || !perfil?.idUnidade) return;

    setLoadedData(true);
    try {
      const response = await service.findAll();
      setData(response.data || []);
    } catch (error) {
      console.error('Erro ao buscar funcionários:', error);
    } finally {
      setLoadedData(false);
    }
  }

  useEffect(() => {
    if (perfil?.idPerfil && perfil?.idEmpresa && perfil?.idUnidade) {
      fetchFuncionarios();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: async () => ({ data: [] }),
              deleteOne: async thisData => {
                const response = await service.deleteOne({ id: thisData.id });
                await fetchFuncionarios();
                return response;
              },
            }}
            informationPage={{
              title: 'Cadastro de Funcionários',
              subTitle: 'Cadastre e gerencie a ficha dos colaboradores da empresa',
              icone: 'submenu-usuarios',
            }}
            loaded={loadedData}
          >
            <CustomBodyContent data={data} loadedData={loadedData} />

            <SLEditModal title="Atualizar Funcionário" setter={setMountedData}>
              {mountedData && <EditContent mountedData={mountedData} refetch={fetchFuncionarios} />}
            </SLEditModal>

            <SLCreateModal title="Cadastro de Funcionário">
              <CreateContent refetch={fetchFuncionarios} />
            </SLCreateModal>
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
